import React from "react";
import { Auth0Provider } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";

const Auth0ProviderWithHistory = ({ children }) => {
  const navigate = useNavigate();

  const onRedirectCallback = (appState) => {
    const redirectTo = localStorage.getItem("redirectTo") || "/";
    navigate(redirectTo);
    setTimeout(() => {
      window.localStorage.removeItem("redirectTo");
    }, 100);
  };
  

  return (
    <Auth0Provider
      authorizationParams={{
        redirect_uri: window.location.origin + "/callback",
        audience: process.env.REACT_APP_AUDIENCE,
        scope: "openid profile email offline_access",
      }}
      domain={process.env.REACT_APP_AUTH0_DOMAIN}
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
      onRedirectCallback={onRedirectCallback}
      cacheLocation="localstorage"
      useRefreshTokens={true}
      onError={(error) => console.error("Auth0 Error:", error)}
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithHistory;
